import React, { useEffect, useState } from 'react';
import DwFormField from '@ui/formfield/DwFormField';
import formutils from '@utils/formutils';
import api from '@utils/api';
import Tooltip from '@ui/tooltip/Tooltip';
import { Form } from 'react-final-form';
import { useTranslation } from 'react-i18next';
const ExpressTaxInfoForm = ({ setIsValidTaxForm }) => {
    // Apply for HK only
    if (window.country != 'HK')
        return null;
    const { t } = useTranslation();
    const [formdef, setFormdef] = useState(window.country == 'HK'
        ? {
            taxCode: {
                htmlValue: '',
                mandatory: true,
                dynamicHtmlName: 'dwfrm_billing_taxCode',
                valid: false,
                error: t('error.message.invalid'),
                label: 'HKID/BR number',
                maxLength: 16,
                formType: 'formField',
            },
        }
        : {});
    const validate = async (values) => {
        values.taxCode = (values.taxCode || '').toUpperCase();
        let errors = await formutils.validateForm(values, formdef, 'express-checkout-taxcode');
        if (!values.taxCode) {
            errors['taxCode'] = t('label.requiredfield');
            return errors;
        }
        if (!errors['taxCode']) {
            setIsValidTaxForm(true);
            return;
        }
        if (errors['taxCode']) {
            setIsValidTaxForm(false);
        }
        return errors;
    };
    const handleSubmit = (values) => {
        // Validation is done in validate()
    };
    // Download HK taxCode form definition
    useEffect(() => {
        api.getForm('express-checkout-taxcode', {}).then((data) => {
            if (data) {
                setFormdef(data);
            }
        });
    }, []);
    return (React.createElement(Form, { onSubmit: handleSubmit, initialValues: {}, validate: validate, mutators: {
            global: formutils.globalMutator,
            setValue: ([key, value], state, { changeValue }) => {
                console.log('setValue ' + key + '=' + value);
                changeValue(state, key, () => value);
            },
        }, render: ({ handleSubmit, form, submitting, pristine, values, validating }) => (React.createElement("form", { onSubmit: handleSubmit, id: "form-submitpayment", onBlur: handleSubmit },
            React.createElement("div", { className: "express-payments-hk-tax-code mt-16" },
                React.createElement("div", { className: "invoice-block" },
                    React.createElement(Tooltip, { ariaLabel: t('label.info'), id: "taxCode", text: t('checkout.hbidtooltip') }),
                    React.createElement(DwFormField, { groupClassName: "mt-16", def: formdef, name: "taxCode", validTick: true }))))) }));
};
export default ExpressTaxInfoForm;
